export default __webpack_public_path__ + "static/media/Increase_sales_close_more_deals_google_slides.ddca8ee4.gif";